import React from "react";
import { Link } from "react-router-dom";
import footerlogo from "./images/footer_logo.png";

const Footer = () => {
  return (
    <div>
      <div class="container-fluid footer-container">
        <div class="container">
          <div class="row">
            <div class="col-md-6">
              <a href="https://www.mmopro.org" target={"_blank"}>
                {" "}
                <img src={footerlogo} alt="" />
              </a>
            </div>
            <div class="col-md-3 footer-col">
              <h5>MMO NFTs</h5>
              <li>
                <Link to="/explore" target={"_blank"}>
                  Explore
                </Link>
              </li>
              <li>
                <Link to="/howitworks" target={"_blank"}>
                  How it works
                </Link>
              </li>
              <li>
                <Link to="/community" target={"_blank"}>
                  Community
                </Link>
              </li>
              <li>
                <Link to="/privacypolicy" target={"_blank"}>
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/Tos" target={"_blank"}>
                  Terms of Service
                </Link>
              </li>
            </div>
            <div class="col-md-3 footer-col">
              <h5>Social</h5>
              <li>
                <a
                  href="https://twitter.com/MMOProOfficial"
                  target="_blank"
                  rel="noreferrer"
                >
                  Twitter
                </a>
              </li>
              <li>
                <a
                  href="https://discord.mmopro.org"
                  target="_blank"
                  rel="noreferrer"
                >
                  Discord
                </a>
              </li>
              <li>
                <a
                  href="https://t.me/mmoprocoin"
                  target="_blank"
                  rel="noreferrer"
                >
                  Telegram
                </a>
              </li>
              <li>
                <a
                  href="https://www.facebook.com/MMOProDotOrg/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Facebook
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/mmoproofficial/"
                  target="_blank"
                >
                  Instagram
                </a>
              </li>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
